/**
 * Users list for the granular-permissions admin surface (`GET /v3/users`).
 *
 * Intentionally separate from the legacy `ApiUserPermissionsListing`, which keeps serving `GET /users`.
 */
export interface ApiPermissionsUserV3 {
  first_name: string;
  last_name: string;
  email: string;
  twrn: string;
  profile_photo_url: string | null;
  is_super_admin: boolean;
  /** Count of teams the user is assigned to, including `NO_ACCESS` assignments. */
  teams_count: number;
  /** Display names for the user's team assignments (tooltip source for the Teams column). */
  team_names: string[];
  /** ISO timestamp of the user's last permission change, `null` if never changed. */
  updated_at: string | null;
}

export interface ApiPermissionsUsersV3Response {
  data: ApiPermissionsUserV3[];
}

export class PermissionsUserV3 {
  firstName: string;
  lastName: string;
  email: string;
  twrn: string;
  avatar: string | null;
  isSuperAdmin: boolean;
  teamsCount: number;
  teamNames: string[];
  updatedAt: string | null;

  constructor(data: ApiPermissionsUserV3) {
    this.firstName = data.first_name;
    this.lastName = data.last_name;
    this.email = data.email;
    this.twrn = data.twrn;
    this.avatar = data.profile_photo_url;
    this.isSuperAdmin = data.is_super_admin;
    this.teamsCount = data.teams_count;
    this.teamNames = data.team_names;
    this.updatedAt = data.updated_at;
  }

  get fullName(): string {
    return `${this.firstName} ${this.lastName}`;
  }

  static fromApi(data: ApiPermissionsUserV3): PermissionsUserV3 {
    return new PermissionsUserV3(data);
  }
}
